import { Injectable } from "@angular/core";
import { ProductService } from "../services/product.service";
import { Product, ProductVariants } from "../models/product.schema";
import { ProductVariantsService } from "../services/product-variants.service";

@Injectable({
    providedIn: 'root'
})

export class AutoGeneratedSkuService { 

    constructor(
        private productService: ProductService,
        private productVariantsService: ProductVariantsService,
    ){}
    
    async autoGeneratedSku(): Promise<string> {
        try {
            let sku: string;
            let existingProduct: Product | null;
            
            do {
                sku = await this.autoGeneratedSkuFunction();
                existingProduct = await this.productService.findProduct(sku);
            } while (existingProduct);

            return sku;
        } catch (error) {
            console.error("Error generating SKU:", error);
            throw error;
        }
    }

    async autoGeneratedSkuFunction(): Promise<string> {
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
        let result = '';
        for (let i = 0; i < 6; i++) {
            const randomIndex = Math.floor(Math.random() * characters.length);
            result += characters[randomIndex];
        }
        return result;
    }

    async autoGeneratedVariantSku(): Promise<string> {
        try {
            let sku: string;
            let existingProductVariant: ProductVariants | null;
            
            do {
                sku = await this.autoGeneratedSkuFunction();
                existingProductVariant = await this.productVariantsService.findProductVariantWithSku(sku);
            } while (existingProductVariant);

            return sku;
        } catch (error) {
            console.error("Error generating SKU:", error);
            throw error;
        }
    }
}